<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/customer-receipt/table">客户开票信息列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">表单</span>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="公司名称"
                          prop="company_name">
              <label>{{ form.company_name }}</label>
            </el-form-item>
            <el-form-item label="开户行及账户"
                          prop="bank_info">
              <label>{{ form.bank_info }}</label>
            </el-form-item>
            <el-form-item label="地址及电话"
                          prop="address_phone">
              <label>{{ form.address_phone }}</label>
            </el-form-item>
            <el-form-item label="税号"
                          prop="tax_number">
              <label>{{ form.tax_number }}</label>
            </el-form-item>
            <el-form-item label="附件" prop="attached_file">
              <div class="view-navbar">
                <ul class="clear-both">
                  <li v-for="(item, index) in form.attached_file" :key="index">
                    <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
                      <img v-if="item.type === 'pic'" style="width: 100px; height: 100px" :src="item.tmp_url" @click="onViewImage">
                      <i v-if="item.type === 'pdf' || item.type === 'eml'"
                          class="sj-icon-pdf"
                          style=" font-size:100px; margin-top: 50px"
                          @click="onGetPdfFile(item, index)"></i>
                    </el-tooltip>
                  </li>
                </ul>
              </div>
            </el-form-item>
            <el-form-item label="使用客户" prop="customer_infos">
            <div class="market" v-for="(item, index) in form.customer_infos" :key="index">
              <label>{{index + 1}}、 {{item.name}} / {{item.number}} / {{item.id}}</label>
            </div>
            </el-form-item>
            <el-form-item label="账期" prop="pay_condition_ids">
            <div class="market" v-for="(item, index) in form.pay_condition_infos" :key="index">
              <label>{{index + 1}}、 {{item.name}} / {{item.id}}</label>
            </div>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <el-button @click="$router.back()">返回</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'viewerjs'
import downloadJS from '@/vendor/download'
import { getToken } from '@utils/auth'

export default {
  components: {},
  data () {
    return {
      id: 0,
      form: {
        company_name: '',
        bank_info: '',
        address_phone: '',
        tax_number: '',
        attached_file: [],
        customer_ids: [],
        customer_infos: [],
        pay_condition_ids: [],
        pay_condition_infos: [],
      },
      fileList: [],
    }
  },
  computed: {},
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    ...request.map(['getCustomerTable']),
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setForm (id) {
      request.common('getCustomerReceiptDetail', {id}).then(({data}) => {
        filter.setLoop(this.form, data)
        this.setCustomerInfo()
        this.setCollectCondition()
      })
    },
    setCustomerInfo () {
      let customerInfos = []
      request.common('getCustomerTable', {ids: this.form.customer_ids, type: 'all'}).then(({data}) => {
        this.form.customer_ids.forEach(id => {
          let target = data.data.find(el => el.id * 1 === id * 1)
          if (target) {
            customerInfos.push(target)
          } else {
            customerInfos.push({id, number: '-', name: '客户数据不存在，请检查是否被删除'})
          }
        })
        this.form.customer_infos = customerInfos
      })
    },
    setCollectCondition () {
      request.common('queryPayCondition', {id: this.form.pay_condition_ids}).then(({data}) => {
        this.form.pay_condition_infos = data.data
      })
    },
    getCustomerInfoRemote (id) {
      return request.common('getCustomerDetail', id)
    },
    onGetPdfFile (item) {
      this.$confirm('确认下载文件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        downloadJS(request.items.getFinCenterFileUrlForDownload(item), false, false, {
          'SJ-Auth-Token': getToken()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '下载已取消',
        })
      })
    },
    onViewImage (event) {
      if (event.target.src) {
        this.views = new Viewer(event.target, {
          url: (image) => event.target.src,
        })
      }
      this.views.view()
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>

.view-navbar {
  right: 0px;
  bottom: 0px;
  width: 100%;
  overflow: hidden;
  display: inline;
  float: left;
}
ul {
  transform: translateX(0px);
  transition: all 0.3s;
  box-sizing: content-box;
  // height: 100px;
  overflow: hidden;
  padding: 1px 0;
}
li {
  float: left;
  list-style: none;
  width: 100px;
  height: 100px;
  margin-right: 5px;
  cursor: pointer;
  font-size: 0;
  line-height: 0;
  overflow: hidden;
  transition: opacity 0.15s;
}
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/customer-receipt/pages/CustomerReceiptDetail.vue